export default "__VITE_ASSET__ab178230__"